// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","left":"Header_left__AgymK","title":"Header_title__l+wMf","right":"Header_right__sCxx3"};